import { render, staticRenderFns } from "./ProductElabel.vue?vue&type=template&id=37b2fc5d&scoped=true"
import script from "./ProductElabel.vue?vue&type=script&lang=js"
export * from "./ProductElabel.vue?vue&type=script&lang=js"
import style0 from "./ProductElabel.vue?vue&type=style&index=0&id=37b2fc5d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2fc5d",
  null
  
)

export default component.exports